import React from 'react'
import { keys } from 'lodash'
import './../index.scss'
import { ns } from '../constants'

function Kpi({ data, t }) {
  const translate = (n) => t(`${ns}.${n}`)

  return (
    <div className='kpi-container'>
      {keys(data).map((dataKey) => (
        <div className='text-container' key={dataKey}>
          <h6 className='title'>{translate(dataKey.toUpperCase())}</h6>
          <p className='value'>{data[dataKey]}</p>
        </div>
      ))}
    </div>
  )
}

export default Kpi
